export default {"src":"/_next/static/media/backend.6e2bda55.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};